// extracted by mini-css-extract-plugin
export default {"panel":"Panel_panel__xJK1f","info":"Panel_info__BD5Ki","note":"Panel_note__-MM+z","close":"Panel_close__48dTV","btns":"Panel_btns__IIgzT","button":"Panel_button__n+5sA"};